export enum UserStatus {
  WaitingForApproval = 'waitingApproval',
  PendingEmailValidation = 'pendingEmailValidation',
  Pending = 'pending',
  Active = 'active',
  Inactive = 'inactive',
  Deleted = 'deleted',
}
